export default __webpack_public_path__ + "static/media/calender.866611b4.png";